import { render, staticRenderFns } from "./CadastroTestePrincipal.vue?vue&type=template&id=061fa106&"
import script from "./CadastroTestePrincipal.vue?vue&type=script&lang=js&"
export * from "./CadastroTestePrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports